import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SEO from "@/components/SEO";
import { Reveal } from "@/components/Reveal";
import { PageHero } from "@/components/site";
import { api } from "@/lib/api";

const PILLAR_ORDER = ["Technology Advisory", "Cyber Security Advisory", "Governance & Resilience", "Transformation & Enablement"];

export default function IndividualServices() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/services").then(({ data }) => setServices(data)).catch(() => {}).finally(() => setLoading(false)); }, []);
  const grouped = PILLAR_ORDER.map((pillar) => ({ pillar, items: services.filter((s) => s.pillar === pillar) }));

  return (
    <div data-testid="page-individual-services">
      <SEO title="Services & Pricing" description="TWORAY services and pricing — individual advisory and enablement services across technology, cyber security, governance and Microsoft 365, with transparent prices." />
      <PageHero overline="Services & Pricing" title="Individual services, transparent pricing."
        subtitle="Engage services individually or as part of a package. All prices exclude VAT and are indicative, subject to scope confirmed in a written proposal." />

      <section className="py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          {loading ? (<div className="text-center text-slate">Loading services…</div>) : (
            <div className="space-y-16">
              {grouped.map((g) => (
                <div key={g.pillar}>
                  <Reveal><h2 className="font-heading font-bold text-2xl text-navy border-b border-brandborder pb-4">{g.pillar}</h2></Reveal>
                  <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                    {g.items.map((s, i) => (
                      <Reveal key={s.slug} delay={i * 0.05}>
                        <div data-testid={`capability-${s.slug}`} className="group bg-white border border-brandborder rounded-md p-6 h-full flex flex-col hover:border-brandblue transition-colors duration-300">
                          <div className="flex items-start justify-between gap-3">
                            <h3 className="font-heading font-semibold text-lg text-navy">{s.name}</h3>
                            <span className="font-heading font-bold text-navy whitespace-nowrap">{s.price}</span>
                          </div>
                          <p className="mt-2 text-sm text-slate leading-relaxed flex-1">{s.summary}</p>
                          <div className="mt-5 flex items-center justify-between">
                            <span className="text-xs text-slate">excl. VAT</span>
                            <Link to={`/book?service=${encodeURIComponent(s.name)}`} className="inline-flex items-center gap-1 text-brandblue font-semibold text-sm group-hover:gap-2 transition-all" data-testid={`capability-cta-${s.slug}`}>
                              Enquire <ArrowUpRight size={15} />
                            </Link>
                          </div>
                        </div>
                      </Reveal>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
